<template>
  <div class="pa-5">
    <!--タイトル(事例)-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--導入事例-->
    <v-card
    v-for="(list, i) in lists"
    :key="i"
    class="pa-3 ma-3 mb-"
    elevation="5">
    <div class="pt-3">
    <!--事例タイトル-->
      <v-icon color="blue darken-4">
        {{ listIcon }}
      </v-icon>
      <span id="listTitle">
      {{ list.title }}
      </span>

      <!--内容-->
      <v-list
      two-line
      class="pa-5">
        <v-list-item
        v-for="(content, i) in list.contents"
        :key="i">

          <v-list-item-content>
            <v-list-item-title>
              <v-icon>
                {{ content.icon }}
              </v-icon>
              {{ content.head }}
            </v-list-item-title>
            <p>
              {{ content.description }}
            </p>
          </v-list-item-content>

        </v-list-item>
      </v-list>
    </div>
    </v-card>
  </div>
</template>

<style>
#listTitle {
  font-size: 19px;
  border-bottom: solid #778899 5px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '事例',
      // タイトル横のアイコン
      icon: 'mdi-file-document-outline',
      // 見出しのアイコン
      listIcon: 'mdi-cogs',
      // 事例のリスト
      lists: [
        {
          title: 'Moodleの導入',
          contents: [
            {
              icon: 'mdi-home-city',
              head: '導入先',
              description: '国立大学医学部'
            },
            {
              icon: 'mdi-laptop',
              head: 'システムの用途',
              description: 'オンライン期末試験システムとして'
            },
            {
              icon: 'mdi-hammer-wrench',
              head: '弊社の取組内容',
              description: 'サーバーの構築、及び運用保守・Moodle導入、及び運用保守・LDAP連携・オリジナルフォーマットで作成された試験問題集からMoodle XMLを出力するシステムの開発'
            }
          ]
        },
        {
          title: 'BigBlueButton(オンライン会議システム)の導入',
          contents: [
            {
              icon: 'mdi-home-city',
              head: '導入先',
              description: '一般企業'
            },
            {
              icon: 'mdi-laptop',
              head: 'システムの用途',
              description: '支店間のTV会議システムとして'
            },
            {
              icon: 'mdi-hammer-wrench',
              head: '弊社の取組内容',
              description: 'サーバーの構築・及び運用保守・会議室のカスタマイズ'
            }
          ]
        },
        {
          title: 'Joomlaの導入',
          contents: [
            {
              icon: 'mdi-home-city',
              head: '導入先',
              description: '一般社団法人'
            },
            {
              icon: 'mdi-hammer-wrench',
              head: '弊社の取組内容',
              description: '店舗検索システムを開発'
            }
          ]
        }
      ]
    }
  }
}
</script>
